var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expire-page-wrap"},[_c('div',{staticClass:"title"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('error.page.linkExpired.content'))}})]),_c('div',{staticClass:"expire-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }